import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'

import { getUserQuery } from '@/lib/queries/business/v2/user/queries'

import { ACCOUNT_DELETION_STEP_MAP } from './constants'
import { type AccountDeletionStep } from './types'

export const useDeleteAccountPage = () => {
  const navigate = useNavigate()

  const [currentStep, setCurrentStep] = useState<AccountDeletionStep>(ACCOUNT_DELETION_STEP_MAP.verifyAccount)

  const { data: dataUser } = useQuery(getUserQuery)

  const subscriptionData = dataUser?.subscription
  const subscriptionExpiryDate = subscriptionData?.expiresDate ?? ''

  const backToSettingsPage = () => {
    void navigate({ to: '/settings' })
    setCurrentStep(ACCOUNT_DELETION_STEP_MAP.verifyAccount)
  }

  const handleSuccessAccountVerification = () => {
    if (!subscriptionData) {
      setCurrentStep(ACCOUNT_DELETION_STEP_MAP.confirmWithoutSubscription)
      return
    }

    if (subscriptionData.isCancelScheduled) {
      setCurrentStep(ACCOUNT_DELETION_STEP_MAP.confirmWithSubscription)
      return
    }

    if (!subscriptionData.isCancelScheduled) {
      setCurrentStep(ACCOUNT_DELETION_STEP_MAP.guideToUnsubscribe)
      return
    }
  }

  return {
    currentStep,
    subscriptionExpiryDate,
    backToSettingsPage,
    handleSuccessAccountVerification,
  }
}
